const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.tagsView.visitedViews,
  operateData: state => state.dataOperate.operateData,
  role: state => state.role,
  language: state => state.language,
  appName: state => state.appName
}
export default getters
